import * as Yup from 'yup'
import i18n from 'core/common/i18n'

type TField = {
  name: string
}

const defaultFieldSchema = Yup.array()
  .ensure()
  .min(1, i18n.t('multivariation.validation.requiredAtLeast'))

export const getValidationSchemaByFieldNames = (fields: TField[]) => {
  const entries = fields.map(({ name }) => [name, defaultFieldSchema])
  return Yup.object().shape(Object.fromEntries(entries))
}
